import React from "react";


const DashboardCard = ({ title, value, icon: Icon, subtitle ,background}) => {
  
  return (
    <div className={`lms-closure-dashboard-card lms-closure-dashboard-card-${background}`}>
      <div className="lms-closure-dashboard-card-header">
        <h4 className="lms-closure-dashboard-card-title">{title}</h4>
        {Icon && <Icon className="lms-closure-dashboard-card-icon" />}
      </div>
      <div className="lms-closure-dashboard-card-body">
        <div className="lms-closure-dashboard-card-value">{value}</div>
        <p className="lms-closure-dashboard-card-subtitle">{subtitle}</p>
      </div>
    </div>
  );
};

export default DashboardCard; 